export default function submitContactForm(
  reCaptchaToken: string,
  formId: string,
  subject: string,
  email: string,
  body: string
) {
  const formData = new FormData();
  formData.append('_wpcf7', formId);
  formData.append('_wpcf7_version', '5.6.3');
  formData.append('_wpcf7_locale', 'en_US');
  formData.append('_wpcf7_unit_tag', `wpcf7-f${formId}-o1`);
  formData.append('_wpcf7_container_post', '0');
  formData.append('_wpcf7_posted_data_hash', '');
  formData.append('_wpcf7_recaptcha_response', reCaptchaToken);

  formData.append('subject', subject);
  formData.append('user-email', email);
  formData.append('body', body);

  const url = `https://www.watco.com/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback`;

  return fetch(url, {
    method: 'POST',
    headers: {
      // 'Content-Type': 'multipart/form-data',
      'Accept': 'application/json, */*;q=0.1'
    },
    body: formData
  })
}